import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import {TagAvatar} from './TagAvatar';
import {VariableAvatar} from './VariableAvatar';
import {TriggerAvatar} from './TriggerAvatar';

export default class DataChip extends React.Component {
  constructor(props) {
    super(props);
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(data){
    this.props.chipClick(data, this.props.tagType);
  }

  render(){

    const style = {
        margin: 2,
    };
    //console.log(this.props.value)
    let src ='';

    if (this.props.tagType === 'tag'){
        src = TagAvatar[this.props.value.type];
    }else if (this.props.tagType === 'variable'){
        src = VariableAvatar[this.props.value.type];
    }else if (this.props.tagType === 'trigger'){
        src = TriggerAvatar[this.props.value.type];
    }


//fallback
    if (typeof src === 'undefined'){
      src = "data:image/png;base64,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";
    }

    return (
        <Chip
          variant="outlined"
          size="small"
          avatar={<Avatar src={src}/>}
          label={this.props.value.name}
          onClick={()=>this.clickHandler(this.props.value)}
          style={style}
        />
    );

  }
}
